import React, { Component } from "react";
import s from "./OBLoader.styles.scss";
import spinner from "../../media/images/spinner.png";
import { Styled } from "../../../toolkit/decorators/Artifact";

interface Props {
  loading: boolean;
  activity: string;
}

interface State {}

@Styled(s)
export default class OBLoader extends Component<Props, State> {
  render() {
    return (
      <div className={s.loaderRoot}>
        <div className={s.spinnerContainer}>
          <div className={s.spinner}>
            <img src={spinner} alt="<->" />
          </div>
        </div>
        <div className={s.title}>{this.props.activity}</div>
      </div>
    );
  }
}
